var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indexpage",attrs:{"id":"app"}},[_c('article',{staticClass:"mainContent"},[_c('HamburgerMenu',{attrs:{"item":{
        homeUrl: _vm.homeUrl,
        cateUrl: _vm.cateUrl
      }}}),(_vm.getDeviceType === 'SP')?_c('div',{attrs:{"id":"fsvs-body"}},[_c('div',{staticClass:"slide",attrs:{"id":"top"}},[_c('div',{staticStyle:{"position":"relative"}},[_c('HeaderBox',{attrs:{"item":{
              homeUrl: '../',
              cateUrl: _vm.cateUrl
            }}})],1),_c('CategoryHeader',{attrs:{"item":{
            categoryName: _vm.categoryName,
            categoryIntro: _vm.categoryIntro
          }}})],1),_vm._l((_vm.sortedCategoryListByRank),function(list){return _c('div',{key:list[4],staticClass:"slide position-relative",attrs:{"id":list[4]}},[_c('CategorySlideSp',{attrs:{"item":{
            no: list[0],
            categoryId: list[1],
            categoryName: list[2],
            rank: list[3],
            magazineId: list[4],
            customMagazineDescription: list[5],
            authorComment: list[6],
            userComment: list[7],
            magazineTitle: list[8],
            coverImage: list[9],
            cycleType: list[10],
            magazineIdView: list[11],
            magazineDescription: list[12],
            free: list[13],
            firstMonthPayFlag: list[14],
            basicPriceWithTax: list[15]
          }}})],1)}),_c('div',{staticClass:"slide scrollable",staticStyle:{"overflow-y":"scroll"},attrs:{"id":"footer"}},[_c('CategorySpBackButton'),_c('CategoryButtons',{attrs:{"item":{
            cateUrl: _vm.cateUrl
          }}}),_c('OldMag2Year'),_c('IncFooter',{attrs:{"item":{
            copyYear: _vm.copyYear
          }}})],1)],2):_vm._e(),(_vm.getDeviceType === 'PC')?_c('div',[_c('HeaderBox',{attrs:{"item":{
          homeUrl: _vm.homeUrl,
          cateUrl: _vm.cateUrl
        }}}),_c('CategoryHeader',{attrs:{"item":{
          categoryName: _vm.categoryName,
          categoryIntro: _vm.categoryIntro
        }}}),_c('section',{staticClass:"cateSection"},[_c('div',{staticStyle:{"padding":"0"}},_vm._l((_vm.sortedCategoryListByRank),function(list){return _c('div',{key:list[4],staticClass:"item_rank_wap_cate"},[_c('CategoryPanel',{attrs:{"item":{
                no: list[0],
                categoryId: list[1],
                categoryName: list[2],
                rank: list[3],
                magazineId: list[4],
                customMagazineDescription: list[5],
                authorComment: list[6],
                userComment: list[7],
                magazineTitle: list[8],
                coverImage: list[9],
                cycleType: list[10],
                magazineIdView: list[11],
                magazineDescription: list[12],
                free: list[13],
                firstMonthPayFlag: list[14],
                basicPriceWithTax: list[15]
              }}})],1)}),0)]),_c('CategoryButtons',{attrs:{"item":{
          cateUrl: _vm.cateUrl
        }}}),_c('OldMag2Year'),_c('IncFooter',{attrs:{"item":{
          copyYear: _vm.copyYear
        }}})],1):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }